import type {AppRouteDefinition, PageRouteConfig} from './types';

export function pageDirFromModulePath(modulePath: string): string {
  const normalized = modulePath.replace(/\\/g, '/');
  const match = normalized.match(/\/pages\/((?:.+\/)?)page\.tsx$/);

  if (!match) {
    throw new Error(`Unexpected page module path: ${modulePath}`);
  }

  const pageDir = match[1] ?? '';

  return pageDir.endsWith('/') ? pageDir.slice(0, -1) : pageDir;
}

export function pageDirToPath(pageDir: string): string {
  if (!pageDir) {
    return '/';
  }

  return `/${pageDir
    .split('/')
    .map((segment) => {
      if (segment.startsWith('[') && segment.endsWith(']')) {
        return `:${segment.slice(1, -1)}`;
      }

      return segment;
    })
    .join('/')}`;
}

export function register(pageDir: string, config: PageRouteConfig): AppRouteDefinition {
  return {
    path: pageDirToPath(pageDir),
    ...config
  };
}

export function registerFromModulePath(
  modulePath: string,
  config: PageRouteConfig
): AppRouteDefinition {
  return register(pageDirFromModulePath(modulePath), config);
}
